import { initializeDatepicker } from '../../components/datepicker.js';

$(() => {
  const datePicker = $('#demo-form div.date-input-wrapper input').get(0);

  initializeDatepicker(datePicker);
});
